type ProgramItemGroupIconProps = {
  size?: number
  color?: string
}

/** CDN の種別アイコン（workgroup.svg 等）と同じ線色（colorPalette に該当色なし） */
const DEFAULT_COLOR = '#888888'
/** CDN の種別アイコン（workgroup.svg 等）と同じ内部塗り色 */
const INNER_FILL = '#F2F2F2'

/**
 * プログラム配下のグループを表すアイコン（Dataset モチーフ）。
 * CDN の種別アイコン（/cdn/global/icons/*.svg）と視覚的な重さを合わせるため、
 * 細い輪郭線＋薄い内部塗り（#F2F2F2）で描画する。
 * AG Grid の全行に描画されるセルでも使うため、emotion を介する SvgIcon ではなく
 * 生 SVG で軽量に描画する。
 */
export const ProgramItemGroupIcon = ({
  size = 16,
  color = DEFAULT_COLOR,
}: ProgramItemGroupIconProps) => (
  <svg
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill="none"
    style={{ flexShrink: 0 }}
  >
    {/* 外枠 */}
    <rect
      x="2.5"
      y="2.5"
      width="15"
      height="15"
      rx="1.2"
      fill={INNER_FILL}
      stroke={color}
      strokeWidth="1"
    />
    {/* 内側の4つの四角 */}
    <rect x="6" y="6" width="3" height="3" fill={color} />
    <rect x="11" y="6" width="3" height="3" fill={color} />
    <rect x="6" y="11" width="3" height="3" fill={color} />
    <rect x="11" y="11" width="3" height="3" fill={color} />
  </svg>
)
